export default "__VITE_ASSET__CQ1hTqCg__"